// extracted by mini-css-extract-plugin
module.exports = {"box":"DataLinesDiagram_box__22Nd8","diagram":"DataLinesDiagram_diagram__3OonP"};